import Parser from "../models/Parser";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class ModelParserMixin extends Vue {
  $parseModel(list) {
    return Parser.parse(list);
  }
}
